import {apiCore} from "./apiCore";

const accreditationOtpApi = apiCore
    .injectEndpoints({
        endpoints: (build) => ({
            GetAccreditationOtp: build.mutation({
                query: () => ({
                    url: '/init-accredit-otp/',
                    body: {},
                    method: "POST",
                })
            }),
            GetAccreditationResendOtp: build.mutation({
                query: () => ({
                    url: '/resend-accredit-otp/',
                    body: {},
                    method: "POST",
                })
            }),
            sendAccreditationOtpCode: build.mutation({
                query: (arg) => ({
                    url: '/accredit-score/',
                    body: {
                        otp: arg?.otp
                    },
                    method: "POST",
                }),
                invalidatesTags: ['get-user-auth-status'],
            }),
            iranianAccreditationScoreRequest: build.query({
                providesTags: ['show-accredit-report'],
                query: () => '/show-accredit-report/'
            })
        })
    })

export const {
    useGetAccreditationOtpMutation,
    useGetAccreditationResendOtpMutation,
    useSendAccreditationOtpCodeMutation,
    useIranianAccreditationScoreRequestQuery
} = accreditationOtpApi
